const reportItems = [
  {
    value: "Fake Profile",
    label: "Fake Profile",
  },
  {
    value: "Inappropriate Messages",
    label: "Inappropriate Messages",
  },
  {
    value: "Sexual / Vulgar Content",
    label: "Sexual / Vulgar Content",
  },
  {
    value: "Asked for Money or Gifts",
    label: "Asked for Money or Gifts",
  },
  {
    value: "Scam or Fraudulent Intentions",
    label: "Scam or Fraudulent Intentions",
  },
  {
    value: "Offensive Language or Behavior",
    label: "Offensive Language or Behavior",
  },
  {
    value: "Threats or Harassment",
    label: "Threats or Harassment",
  },
  {
    value: "Unwanted Contact / Spamming",
    label: "Unwanted Contact / Spamming",
  },
  {
    value: "Profile Photo is Misleading or Inappropriate",
    label: "Profile Photo is Misleading or Inappropriate",
  },
  {
    value: "Age / Personal Info Mismatch",
    label: "Age / Personal Info Mismatch",
  },
  {
    value: "Suspicious Activity",
    label: "Suspicious Activity",
  },
  {
    value: "Using for Business or Promotion",
    label: "Using for Business or Promotion",
  },
  {
    value: "Other (Please Specify)",
    label: "Other (Please Specify)",
  },
];
export default reportItems;
